
export default {
  props: {
    resources: {
      type: Array,
      required: true
    },

    load: {
      type: Function,
      default: function _default() {}
    },

    size: {
      type: String,
      default: 'medium'
    },

    disabledScroll: {
      type: Boolean,
      default: false
    },
    frames: {
      type: Number,
      default: 0
    }
  },

  data: function data() {
    return {
      currentId: 0
    };
  },
  mounted: function mounted() {},


  methods: {
    handleMouseEnter: function handleMouseEnter(_ref) {
      var id = _ref.id;

      this.currentId = id;
    },
    handleMouseLeave: function handleMouseLeave() {
      this.currentId = 0;
    },
    isDisabledClick: function isDisabledClick(res) {
      if (this.frames) {
        if (res.payload) {
          return JSON.parse(res.payload).frames < this.frames;
        } else if (res.file_urls) {
          return res.file_urls.length < this.frames;
        }
        return true;
      }
      return false;
    }
  }
};